export const useStore = defineStore('Store', {
  state: () => {
    return {
      userAgent: '',
      isMobile: false,
      token: null,
      sidebarVisible: false,
    };
  },
  actions: {
    toggleSidebar () {
      this.sidebarVisible = !this.sidebarVisible;
    },
    closeSidebar () {
      this.sidebarVisible = false;
    },
  },
  getters: {
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useStore, import.meta.hot));
}
